import Image from "next/image";
import beforeSearchImage from "@/assets/images/ai/enterprise-search/before-search.svg";
import withSearchIcon from "@/assets/images/ai/enterprise-search/with-search.svg";
import checkIcon from "@/assets/images/ai/enterprise-search/tick.svg";
import CommonTitle from "../common/CommonTitle";
import CommonSubtitle from "../common/CommonSubtitle";

const WorkSpentSearch = () => {
  const features = [
    {
      id: 1,
      title: "Instant Results",
      description: "Search across all your enterprise data in milliseconds",
    },
    {
      id: 2,
      title: "Enterprise Security",
      description: "RBAC policies and data permissions built-in",
    },
    {
      id: 3,
      title: "50% Faster",
      description: "Reduce time spent searching by half",
    },
    {
      id: 4,
      title: "AI-Powered",
      description: "Conversational AI understands context",
    },
  ];

  return (
    <div className="bg-white px-4 py-12 xl:py-16">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mb-8 text-center">
          <CommonTitle
            color="#202020"
            fontSizeClass="text-[24px] lg:text-[32px] mb-2 lg:mb-4"
            fontWeightClass="font-semibold"
            as="h2"
          >
            <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
              30% of work time
            </span>{" "}
            spent searching
          </CommonTitle>
          <CommonSubtitle
            color="#202020"
            fontSizeWeight="max-w-[900px] mx-auto text-center"
          >
            Your team wastes countless hours searching for data across
            disconnected systems.
          </CommonSubtitle>
        </div>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-2xl bg-gradient-to-b to-[#F4F4FD] from-[#ffffff]">
            <div className="rounded-t-2xl  bg-gradient-to-b to-[#F4F4FD] from-[#ffffff] px-4 py-6 lg:px-6 lg:py-12">
              <h3 className="text-center text-[20px] font-bold text-[#202020] xl:text-[24px]">
                Before Enterprise Search
              </h3>
            </div>
            <div className="flex h-[300px] w-full items-center justify-center p-4 lg:h-[400px] lg:p-6">
              <Image
                src={beforeSearchImage}
                alt="Search - Enterprise search"
                className="h-full w-full object-contain"
                width={300}
                height={300}
              />
            </div>
            <p className="pb-6 text-center text-sm text-[#202020] xl:text-base">
              Multiple logins. Endless searching. Lost productivity.
            </p>
          </div>
          <div className="rounded-2xl bg-gradient-to-b to-[#F4F4FD] from-[#ffffff]">
            <div className="rounded-t-2xl bg-gradient-to-r from-[#781E8F] to-[#422CBB] px-4 py-6 lg:px-6 lg:py-8">
              <div className="flex items-center justify-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center lg:h-16 lg:w-16">
                  <Image
                    src={withSearchIcon}
                    alt="Search - Enterprise search"
                    width={48}
                    height={48}
                    className="h-full w-full object-contain"
                  />
                </div>
                <h3 className="border-l-2 border-[#625DFF] pl-4 text-[20px] font-bold text-white lg:max-w-[260px] xl:text-[24px]">
                  With Enterprise Search Engine
                </h3>
              </div>
            </div>
            <p className="p-4 text-center text-sm text-[#202020] xl:text-base">
              Making data accessible with the help of enterprise search software
              instantly. Reducing internal service requests by 50%
            </p>
            <div className="space-y-4 p-6 xl:space-y-8 xl:p-8">
              {features.map((feature) => (
                <div key={feature.id} className="flex items-start gap-3">
                  <div className="flex h-6 w-6 shrink-0 items-center justify-center mt-1">
                    <Image
                      src={checkIcon}
                      alt="Search result verified"
                      width={24}
                      height={24}
                    />
                  </div>
                  <div>
                    <h4 className="mb-1 text-[16px] font-medium text-[#202020] xl:text-[18px]">
                      {feature.title}
                    </h4>
                    <p className="text-[14px] text-[#202020] xl:text-[16px]">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkSpentSearch;
